export default {
  name: '氧气',
  wxName: '氧气语音', // 公众号
  appId: 'wx70df041c5466a26f', // 公众号appId
  appIdBeta: 'wxb5537b7de29f4239', // 公众号appId-beta
  qq: '2853992296', // qq客服号
  projectId: 1001,
  serverHost: 'mizhua', // 协议前缀
  downloadInfo: {
    androidUrl: 'https://download.shuntongtong.com/oxygen/android/ad9999/oxygen_9999.apk',
    iosUrl: 'https://apps.apple.com/cn/app/id1455450133',
  },
  autoGzip: true, // 是否自动判断gzip
  appid: '1',
  secheme: 'mizhua://m.mizhua.com',
  reportUrlKey: 'stat_tracking_ox'
};
